module.exports = __webpack_public_path__ + "img/image27.2e1b750a.png";